import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiHserviceElFindSpecificParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiHserviceElFindSpecificParams, unknown>

const fetchHServiceSpecificList = async (params: ApiHserviceElFindSpecificParams) => {
  const { data } = await apiClient.v2.apiHserviceElFindSpecific(params);
  return checkApiResponse(data);
}

export const hserviceSpecificKeys = {
  all: [QUERY_KEY.v2apiHserviceElFindSpecific] as const,
  list: (params: ApiHserviceElFindSpecificParams) => [...hserviceSpecificKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(hserviceFindSpecificQueryOptions(params))` */
export const hserviceFindSpecificQueryOptions = (params: ApiHserviceElFindSpecificParams) => ({
  queryKey: hserviceSpecificKeys.list(params),
  queryFn: () => fetchHServiceSpecificList(params),
})

export const useHServiceFindSpecificQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: hserviceSpecificKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchHServiceSpecificList(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
